module.exports = __webpack_public_path__ + "static/media/blanket.2bbe1ba4.svg";